// extracted by mini-css-extract-plugin
export default {"Employee":"employee-select_Employee__L5F5K","EmployeeId":"employee-select_EmployeeId__CeWCP"};